// extracted by mini-css-extract-plugin
export default {"imageWrapper":"DK-z","twoColumnImage":"EK-z"};